<div class="text-sm text-foreground-primary-80">{{ title() }}</div>
<ng-content></ng-content>
